module.exports = __webpack_public_path__ + "static/media/icon_mg06s.6f43ed53.svg";